/**
 * Class helpers for channel selection buttons and cadence status badges.
 * Extracted from JSX to avoid nested ternaries.
 */

export function channelButtonClass(currentChannel, buttonChannel) {
  if (currentChannel !== buttonChannel) {
    return "border-white/10 text-white/60 hover:border-white/30";
  }
  if (buttonChannel === "whatsapp") {
    return "border-[#25D366] bg-[#25D366]/10 text-[#25D366]";
  }
  return "border-[#E1306C] bg-[#E1306C]/10 text-[#E1306C]";
}

export function cadenceStatusClass(status) {
  if (status === "active") {
    return "border-[#25D366]/30 text-[#25D366] bg-[#25D366]/5";
  }
  if (status === "paused") {
    return "border-yellow-400/30 text-yellow-400 bg-yellow-400/5";
  }
  return "border-white/10 text-white/60";
}
